
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Index from "./pages/Index";
import Uninstall from "./pages/Uninstall";
import Success from "./pages/Success";
import UninstallSuccess from "./pages/UninstallSuccess";
import ContinueToDownload from "./pages/ContinueToDownload";
import Continue from "./pages/Continue";
import NotFound from "./pages/NotFound";

import Search from "./pages/Search";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/uninstall" element={<Uninstall />} />
          <Route path="/success" element={<Success />} />
          <Route path="/uninstallsuccess" element={<UninstallSuccess />} />
          <Route path="/continue-to-download" element={<ContinueToDownload />} />
          <Route path="/continue" element={<Continue />} />
          
          <Route path="/search" element={<Search />} />
          {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
